"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DebtOptinCss = _interopRequireDefault(require("./DebtOptin.css.js"));

var _radium = _interopRequireDefault(require("radium"));

var _SelectionButton = _interopRequireDefault(require("./SelectionButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DebtOptin = function DebtOptin(_ref) {
  var handlers = _ref.handlers,
      loan_type = _ref.loan_type;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _DebtOptinCss.default.mainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-optin-row-1",
    style: _DebtOptinCss.default['rowBase']
  }, /*#__PURE__*/_react.default.createElement("h2", {
    style: _DebtOptinCss.default.headerText
  }, "Would you like a loan to Consolidate Debt ", /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("em", null, "and")), " for ", loan_type, "?")), /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-optin-row-2",
    style: _objectSpread({}, _DebtOptinCss.default['rowBase'], {}, _DebtOptinCss.default['row2'])
  }, /*#__PURE__*/_react.default.createElement(_SelectionButton.default, {
    button: {
      text: 'Yes',
      color: 'blue'
    },
    handleTheClick: handlers.handleYes
  }), /*#__PURE__*/_react.default.createElement(_SelectionButton.default, {
    button: {
      text: 'No',
      color: 'lightBlue'
    },
    handleTheClick: handlers.handleNo
  })), /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-optin-row-3",
    style: _objectSpread({}, _DebtOptinCss.default['rowBase'], {}, _DebtOptinCss.default['row3'])
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-optin-article-1",
    style: _DebtOptinCss.default.articleHeading
  }, "Debt Consolidation & Debt Settlement"), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-1-content",
    style: _DebtOptinCss.default.articleContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "article-1-item-1",
    style: _DebtOptinCss.default.contentItem
  }, "Debt consolidation is simply bundling all your high interest debt into one easy and manageable payment at a reduced interest rate. It won\u2019t have a negative impact your credit score but it also will not reduce the amount that you owe. In addition, you will usually need to have good credit to qualify for this type of program. This is a great solution for those with healthy credit who want simplify their payments and reduce the interest they are currently paying on their debts."), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-1-item-2",
    style: _DebtOptinCss.default.contentItem
  }, "Debt settlement, also referred to as debt negotiation or debt resolution, is when you negotiate with creditors to pay less than what you owe on your outstanding debt. This type of serviced is designed for people who cannot make required minimum payments and/or are considering bankruptcy. Debt Settlement will have a negative impact on your credit score but chances are your credit has already been tarnished at this point in the game. It may help people resolve debts relatively quickly.")), /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-optin-article-2",
    style: _DebtOptinCss.default.articleHeading
  }, "Types of Debt that Qualify"), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-2-content",
    style: _DebtOptinCss.default.articleContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "article-2-item-1",
    style: _DebtOptinCss.default.contentItem
  }, "The types of debt that qualify are unsecured debts of $10,000 or more."), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-2-item-2",
    style: _DebtOptinCss.default.contentItem
  }, "This includes: ", /*#__PURE__*/_react.default.createElement("b", null, "Credit Card Debt, Personal Loan Debt, Medical Debt")), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-2-item-3",
    style: _DebtOptinCss.default.contentItem
  }, "This Does Not include: Auto Loans, Home Loans"))));
};

var _default = (0, _radium.default)(DebtOptin);

exports.default = _default;

//# sourceMappingURL=DebtOptin.jsx.map